var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10451",
    "data-name": "Group 10451",
    transform: "translate(-148 -2514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    transform: "translate(148 2514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_diagram",
    "data-name": "vuesax/outline/diagram",
    transform: "translate(-127 2286.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diagram",
    transform: "translate(300 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.533,29.564H5.157A5.158,5.158,0,0,1,0,24.408V1.031A1.039,1.039,0,0,1,1.031,0,1.039,1.039,0,0,1,2.063,1.031V24.408A3.1,3.1,0,0,0,5.157,27.5H28.533a1.031,1.031,0,0,1,0,2.063Z",
    transform: "translate(1.719 1.719)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.031,15.813a1.031,1.031,0,0,1-.784-1.705l6.312-7.37a3.805,3.805,0,0,1,2.723-1.32,3.844,3.844,0,0,1,2.819,1.1l1.306,1.306a1.775,1.775,0,0,0,1.279.509,1.681,1.681,0,0,0,1.238-.605L22.235.357A1.034,1.034,0,1,1,23.8,1.7l-6.312,7.37a3.805,3.805,0,0,1-2.723,1.32,3.844,3.844,0,0,1-2.819-1.1L10.657,7.989A1.72,1.72,0,0,0,9.378,7.48a1.681,1.681,0,0,0-1.238.605l-6.312,7.37A1.1,1.1,0,0,1,1.031,15.813Z",
    transform: "translate(5.844 8.595)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H33V33H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.f115af1bc61679b9c4fffd70d8754ce2.svg";
export { ForwardRef as ReactComponent };